import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DataMerchandiseModule } from '@epicuro-next/data/merchandise';
import { DynamicComponentsModule } from '@epicuro-next/platform/dynamic-components';

import { RecommendationPanelComponent } from './components/recommendation-panel/recommendation-panel.component';
import { RecommendationPanelsProviderService } from './services/recommendation-panels-provider.service';

@NgModule({
  imports: [CommonModule, DynamicComponentsModule, DataMerchandiseModule],
  declarations: [RecommendationPanelComponent],
  providers: [RecommendationPanelsProviderService],
  exports: [RecommendationPanelComponent],
})
export class RecommendationPanelsModule {}
